import { Asset } from 'nftx.js';
import { useTranslations } from 'use-intl';
import Icon, { Icons } from '@/components/elements/Icon';
import AssetImage from '@/components/elements/AssetImage';
import { Form, SelectInventoryFormFields } from './types';
import { onQuantityChange, toggleItem } from './utils';
import { ChangeEvent } from 'react';
import NftQuantity from '@/presentation/components/modules/NftQuantity';

export interface SelectInventoryItemProps extends Asset {
  is1155?: boolean;
  setValue: Form['setValue'];
  selectedItems: SelectInventoryFormFields['items'];
  onChange: (
    event:
      | {
          tokenId: `${number}`;
          quantity: bigint | undefined;
        }[]
      | ChangeEvent<Element>
  ) => void;
}

export const SelectInventoryFormItem = ({
  setValue,
  is1155,
  tokenId,
  quantity,
  onChange,
  selectedItems,
  imageUrl,
  name,
  assetAddress,
}: SelectInventoryItemProps) => {
  const t = useTranslations('CreateLiquidityPositionForms.SelectInventory');

  const selectedItem = selectedItems.find((x) => x.tokenId === tokenId);

  return (
    <div className="relative grid">
      <button
        type="button"
        onClick={() => onChange(toggleItem(tokenId, selectedItems))}
        className={`overflow-hidden m-1 ring-2 ${
          selectedItem
            ? 'ring-pink-500 rounded-md'
            : 'ring-transparent hover:ring-gray-300/50 rounded-[3px]'
        }`}
      >
        <AssetImage
          assetAddress={assetAddress}
          tokenId={tokenId}
          imageUrl={imageUrl}
          name={name}
        />
      </button>
      {selectedItem ? (
        <span className="bg-pink-500 absolute top-1.5 right-1.5 p-0.5 rounded-full border border-gray-50">
          <Icon name={Icons.CHECK} className="text-white" size={12} />
        </span>
      ) : null}

      {is1155 && (
        <NftQuantity
          selected={!!selectedItem}
          maxQuantity={Number(quantity)}
          value={Number(selectedItem?.quantity ?? 0n)}
          onChange={(value) => {
            onQuantityChange(
              tokenId,
              BigInt(value),
              selectedItems,
              setValue,
              quantity
            );
          }}
        />
      )}
    </div>
  );
};

export default SelectInventoryFormItem;
